const angular = require('angular');
const app = angular.module('learn-resources');

/**
 * Invitations Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('RegisterWithUserid', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/users/register-with-userid', null, {
    register: {params: {subresource: ''}, method: 'POST', isArray: false}
  });
}]);
